'use client'; // Error components must be Client Components

import { useEffect } from 'react';

import Heading, {
  HeadingSize,
  HeadingTag,
} from '@/components/ui/Heading/Heading';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div>
      <Heading
        tag={HeadingTag.H1}
        size={HeadingSize.H1}
        text="Something went wrong!"
        classes="pb-5 text-charcoal"
        hoverEffect
      />
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  );
}
